import * as React from 'react';

interface CompanySelectionProps {
  selectCompany: (company: string) => void;
  selectedCompany: string;
}

const CompanySelection = (props: CompanySelectionProps) => {
  const isCompanySelected = (company: string) => {
    return props.selectedCompany === company;
  };

  return (
    <div className="company-selector">
      <div className="input-wrapper">
        <label htmlFor="">Yhtiö</label>
        <div
          className={isCompanySelected('verman') ? 'filter active' : 'filter'}
          onClick={() => props.selectCompany('verman')}
        >
          Verman
        </div>
        <div
          className={
            isCompanySelected('bioteekki') ? 'filter active' : 'filter'
          }
          onClick={() => {
            props.selectCompany('bioteekki');
          }}
        >
          Leader / Bioteekki
        </div>
      </div>
    </div>
  );
};

export default CompanySelection;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CompanySelection.tsx